export default __webpack_public_path__ + "static/media/CustomerIndiaMap.0a8d66f0.png";